import { Navigation } from "@mcleod/core/src/Navigation";
import { AutogenLayoutOutstandingLoadTenderTotal } from "./autogen/AutogenLayoutOutstandingLoadTenderTotal";
import {  ClickEvent } from "@mcleod/components";

export class OutstandingLoadTenderTotal extends AutogenLayoutOutstandingLoadTenderTotal {

/** This is an event handler for the onClick event of labelOverallCount. */
  labelOverallCountOnClick(event: ClickEvent) {
    const count = this.mainDataSource.activeRow.get("overall_count");
    if (count > 0) {
        this.navigateToLtx();
    }
  }

  private navigateToLtx() { 
    Navigation.navigateTo("lme/datafusion/LoadTenderExpress", {
      width: window.screen.availWidth,
      height: window.screen.availHeight,
      newTab: true,
      windowDecorators: false
    });
  }
}
